import { IEVersion } from './utils'
(function () {
    const ieVersions = IEVersion()
    if (ieVersions === 9 || ieVersions === 10 || ieVersions === 11) {
        let el = document.createElement('style')
        el.innerHTML = `
            .el-cascader-node__prefix,
            .el-cascader-node__postfix{
                top:10px
            }
        `
        if (ieVersions === 9) {
            import('flex-native')
            el.innerHTML += `
                .el-cascader-panel,
                .el-cascader-node,
                .el-message {
                    display: flex;
                    -js-display: flex;
                }
            `
        }

        document.head.appendChild(el)
        el = null
    }
})()


// WEBPACK FOOTER //
// ./src/utils/handleIeCss.js